import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { CandidateAdapters } from '../adapters';
import { IGetCandidateListApiResponse, IGetCandidateListPayload } from '../types';

export const getCandidateList = async (
  payload: IGetCandidateListPayload,
): Promise<IGetCandidateListApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IGetCandidateListApiResponse>(
    `/recruitment-service/postings/${payload.jobPostingId}/candidates`,
    {
      headers,
      params: CandidateAdapters.toGetCandidateListApiQueryParams(payload),
    },
  );

  return response.data;
};
